import styled from "styled-components";
import { Button } from "./Button";
import { convertHexToRGB, blue, black200 } from "styles/colors";

export const SecondaryButton = styled(Button)`
  border: 2px solid ${blue};
  color: ${blue};
  font-weight: 700;

  &:hover:enabled {
    background: ${convertHexToRGB(blue, 0.08)};
  }
  &:active:enabled {
    background: ${convertHexToRGB(blue, 0.16)};
  }
  &:disabled {
    border-color: ${black200};
    color: ${black200};
  }
`;
